import React from 'react';

export const GreenStars: React.FC = () => {
  const starsCount = 5; // You can adjust this value if you want a different number of stars

  return (
    <div className="h-7 flex">
      {Array.from({ length: starsCount }).map((_, index) => (
        <span
          key={index}
          className="bg-green-500 mr-1 text-white h-6 w-6 text-[22px] leading-[1.2]">
          ★
        </span>
      ))}
    </div>
  );
};
